export var ProductSelectionType;
(function (ProductSelectionType) {
    ProductSelectionType["Config"] = "Config";
})(ProductSelectionType || (ProductSelectionType = {}));
